export const GW = 8;
export const GF = 98;
export const MS = 99;
